const routes = {
    root: '/',
    cabinet: {
        root: 'cabinet',
        history: 'history',
        rxId: {
            root: ':prescriptionId',
            alternatives: 'alternatives',
            verify: 'verify',
            verifyPatient: 'verify-patient',
            providerOffersId: {
                root: ':providerOffersId',
                offer: {
                    root: ':offerId',
                },
            },
        },
        patientId: {
            root: ':patientId',
            digitalRx: {
                root: 'digitalrx',
                rxId: ':prescriptionId',
            },
        },
    },
    claims: {
        root: 'claims',
        history: 'history',
        claimId: ':claimId',
    },
    drug: {
        root: 'drug',
        drugId: {
            root: ':drugId',
            providerOffers: {
                root: ':providerOffersId',
            },
        },
        search: {
            root: 'search',
            drugId: ':drugId',
        },
    },
    transfer: {
        root: ':providerOffersId/:offerId/transfer',
        location: {
            root: 'location',
            verify: {
                root: ':locationId',
                submitted: 'submitted',
            },
        },
    },
    error: 'error',
    forbidden: 'forbidden',
    home: 'home',
    language: 'language',
    notFound: 'not-found',
    logout: 'logout',
    orders: {
        root: 'orders',
        prescriberOrderId: {
            root: ':prescriberOrderId',
            confirmation: 'confirmation',
            details: 'details',
        },
    },
    pharmacy: {
        root: 'pharmacy',
        pharmacyId: ':pharmacyId',
        favorites: 'favorites',
        inNetwork: 'in-network',
    },
    plan: {
        root: 'plan',
        summary: 'summary',
    },
    profile: {
        root: 'profile',
        benefit: 'benefit',
        verify: 'verify',
    },
    startSaving: 'start-saving',
    loginCallback: {
        root: 'login/callback',
    },
    helpCenter: {
        root: 'help',
        sendrx: 'sendrx',
        whatsnew: {
            root: 'whatsnew',
            //adding what's new announcements here
        },
        about: 'about',
        settings: 'account-settings',
        employer: 'employer-plan',
        prescriptionManagement: 'prescription-management',
        familyCare: 'family-care',
        costsAndSavings: 'costs-and-savings',
        privacySecurity: 'privacy-security',
    },
};

export default routes;
